import React, { useState } from "react";
import { UnsavedChangesDialog } from "../../../../common/UnsavedChangesPrompt";
import { hasUnsavedFormChanges } from "../../../../common/formStateDirty";

// EV-N6: the ticket and sponsor dialogs compare the draft with the snapshot
// taken when the dialog opened. Closing with changes (X, backdrop or Esc) asks
// the shared "Save changes before leaving?" question. Save Changes runs the
// dialog's own save, so failed validation keeps the dialog open with its
// errors; Leave discards the draft; the prompt's X returns to the dialog.
export const useWizardDialogUnsavedGuard = <Draft,>({
  draft,
  onSave,
  onLeave,
}: {
  draft: Draft | null;
  onSave: () => void;
  onLeave: () => void;
}) => {
  const [baseline, setBaseline] = useState<Draft | null>(null);
  const [promptOpen, setPromptOpen] = useState(false);
  const requestClose = () => {
    if (
      draft !== null &&
      baseline !== null &&
      hasUnsavedFormChanges({ baseline, current: draft })
    ) {
      setPromptOpen(true);
      return;
    }
    onLeave();
  };
  return {
    // Call with the draft value the dialog opens with.
    snapshot: (initialDraft: Draft) => {
      setBaseline(initialDraft);
      setPromptOpen(false);
    },
    requestClose,
    promptOpen,
    prompt: promptOpen ? (
      <UnsavedChangesDialog
        onStay={() => setPromptOpen(false)}
        onLeave={() => {
          setPromptOpen(false);
          onLeave();
        }}
        onSave={() => {
          setPromptOpen(false);
          onSave();
        }}
      />
    ) : null,
  };
};
